import { render, staticRenderFns } from "./klistbox.vue?vue&type=template&id=2b5ad5c6"
import script from "./klistbox.vue?vue&type=script&lang=js"
export * from "./klistbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports